<template>
  <div class="reg">
    <div class="reg-card">
      <div class="logoLogin">
        <Logo></Logo>
        <p>
          已有账号，
          <span class="nowLogin" @click="$router.push('/login')">
            立即登录
            <i class="el-icon-right"></i>
          </span>
        </p>
      </div>

      <div class="mobile inpFlex">
        <div class="inpCommon"><span style="color: red">*</span>手机号：</div>
        <input type="text" placeholder="请输入手机号码" v-model.number="mobile" />
      </div>

      <div class="code inpFlex">
        <div class="inpCommon"><span style="color: red">*</span>验证码：</div>
        <input
          type="text"
          placeholder="请输入验证码"
          class="codeInp"
          v-model="code"
        />
        <button class="codeBtn" @click="getCode">
          {{
            this.currentSecond === this.second
              ? "获取验证码"
              : this.currentSecond + "s后重新获取"
          }}
        </button>
      </div>

      <div class="pwd inpFlex">
        <div class="inpCommon"><span style="color: red">*</span>密码：</div>
        <input type="password" placeholder="请输入密码" v-model.trim="pwd" />
      </div>

      <div class="againPwd inpFlex">
        <div class="inpCommon"><span style="color: red">*</span>确认密码：</div>
        <input
          type="password"
          placeholder="请输入确认密码"
          v-model.trim="pwdAgain"
          @blur="checkPwd"
        />
      </div>

      <button class="regBtn" @click="reg">注册</button>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { sendCode, reg } from '@/api/common'
export default {
  name: 'RegIndex',
  data () {
    return {
      mobile: '',
      code: '',
      pwd: '',
      pwdAgain: '',
      currentSecond: 60,
      second: 60,
      timerId: null
    }
  },
  methods: {
    checkPwd () {
      if (this.pwd !== this.pwdAgain) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
      }
    },
    async getCode () {
      if (!this.mobile) {
        this.$toast.fail('请输入手机号码')
        return
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.mobile)) {
        this.$toast.fail('手机号格式错误')
        return
      }

      // 可以发送验证码
      if (!this.timerId && this.currentSecond === this.second) {
        await sendCode(this.mobile)
        this.currentSecond--
        this.timerId = setInterval(() => {
          this.currentSecond--
          if (this.currentSecond <= 0) {
            this.currentSecond = this.second
            clearInterval(this.timerId)
            this.timerId = null
          }
        }, 1000)
        this.$toast.success('验证码发送成功')
      }
    },
    async reg () {
      if (!this.mobile || !this.code || !this.pwd || !this.pwdAgain) {
        this.$toast.fail('请输入完整的数据')
        return
      }
      if (this.pwd !== this.pwdAgain) {
        this.$toast.fail('两次输入的密码不一致，请重新输入')
        return
      }
      const result = await reg(this.mobile, this.code, this.pwd, this.pwdAgain)
      this.$toast.success(result.data)
      this.$router.push('/login')
    }
  },
  components: {
    Logo
  }
}
</script>

<style lang="less" scoped>
.reg {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f8fafc, #eef6ff);
  padding: 40px;

  .reg-card {
    width: 480px;
    padding: 40px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0,0,0,0.1);
  }

  .inpCommon {
    width: 80px;
    font-size: 14px;
    color: #303133;
  }

  .inpFlex {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .logoLogin {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .nowLogin {
      cursor: pointer;
      color: #409EFF;
      font-size: 14px;
      transition: all 0.3s ease;

      &:hover {
        color: #67C23A;
        transform: translateX(5px);
      }

      i {
        margin-left: 6px;
        font-size: 12px;
      }
    }
  }

  .mobile,
  .pwd,
  .againPwd,
  .code {
    input {
      flex: 1;
      height: 48px;
      padding: 0 16px;
      font-size: 14px;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      color: #303133;
      background-color: #fff;
      transition: all 0.3s ease;

      &::placeholder {
        color: #c0c4cc;
      }

      &:focus {
        border-color: #409EFF;
        outline: none;
        box-shadow: 0 0 0 3px rgba(64,158,255,.1);
      }
    }
  }

  .code {
    display: flex;
    align-items: center;
    gap: 12px;

    .codeInp {
      width: 300px;
    }

    .codeBtn {
      width: 120px;
      height: 48px;
      color: #fff;
      background: linear-gradient(135deg, #409EFF, #67C23A);
      border: none;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        opacity: 0.95;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(64,158,255,.3);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  .regBtn {
    width: 100%;
    height: 48px;
    margin-top: 30px;
    color: #fff;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    border: none;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.95;
      transform: translateY(-2px);
      box-shadow: 0 4px 15px rgba(64,158,255,.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}
</style>
